// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3f4aA","empty":"ModalGraph_empty__Lve-F"};